// work data
import recdb from '../assets/Images/recdb.png'
import interview from '../assets/Images/interview.png'
import wish from '../assets/Images/wish.png'
import chess from '../assets/Images/chess.png'
import json from '../assets/Images/json.png'
import insta from '../assets/Images/insta.png'
import wtf from '../assets/Images/wtf.png'
import prodigy from '../assets/Images/prodigy.png'
import todo from '../assets/Images/todo.png'
import calculator from '../assets/Images/calculator.png'
export const Work = [
    {
        id:1,
        name:"RECDB",
        description:"A centralized academic hub designed to provide students with unified access to a wide range of study materials.",
        tags:["react","Firebase","Zoho Catalyst"],
        
        demo:"https://rec-db-official.web.app/",
        github:"https://github.com/SITHESWAR-K/recdb-overview.git",
        img:recdb
    },
    {
        id:2,
        name:"INTERVIEWAI",
        description:"fullstack mockinterview platform with end-to-end AI voice interviews, real-time facial emotion detection",
        tags:["react","Firebase","Supabase"],
        
        demo:"https://interviewer-mock.web.app/",
        github:"https://github.com/SITHESWAR-K/mock-interview.git",
        img:interview
    },
    {
        id:3,
        name:"WISHLINK GENERATOR",
        description:"Create and share personalized holiday greeting links for Christmas and New Year.",
        tags:["react","Zoho Slate"],
        
        demo:"https://google.onslate.in/",
        github:"https://github.com/SITHESWAR-K/wishlink-generator.git",
        img:wish
    },
    {
        id:4,
        name:"CHESS BOT",
        description:"The Chess Bot that can play a move based on the user move",
        tags:["react","Render","FastAPI"],
        
        demo:"https://chess-game-frontend-l4q8.onrender.com/",
        github:"https://github.com/recsithes/chess_game.git",
        img:chess
    },
    {
        id:5,
        name:"JSON PROMPT GENERATOR",
        description:"The application empowers users to get higher quality results by translating simple requests into the detailed format AI prefers.",
        tags:["react","AI"],
        
        demo:"https://json-prompt-generator-ai.web.app/",
        github:"https://github.com/SITHESWAR-K/json_prompt_generator",
        img:json
    },
    {
        id:6,
        name:"Instagram Clone",
        description:"A responsive and scalable clone of the Instagram web application to mirror its core user experience and design.",
        tags:["react","catalyst","react-router"],
        
        demo:"https://instagram-clone-in.web.app/",
        github:"https://github.com/SITHESWAR-K/Instagram-Clone",
        img:insta
    },
    {
        id:7,
        name:"CTF Website",
        description:"A cool site provides participants with a clean, user-friendly interface to view event details and navigate to the official competition platform.",
        tags:["Html","CSS","JS","Bootstrap"],
        
        demo:"https://ctf-website-wtf.web.app/",
        github:"https://github.com/SITHESWAR-K/ctf-website.git",
       img:wtf
    },
    {
        id:8,
        name:"Prodigy InfoTech",
        description:"Recreated the landing page and key sections of the Prodigy InfoTech website to demonstrate frontend development and design skills.",
        tags:["Html","CSS","Bootstrap"],
        
        demo:"https://sithes.neocities.org/landing_page/home",
        github:"https://github.com/SITHESWAR-K/Prodigy-InfoTech---clone",
        img:prodigy
    },
    {
        id:9,
        name:"Todo App",
        description:"A clean and intuitive client-side To-Do app to help users create, track, and manage their daily tasks",
        tags:["Html","CSS","JS"],
        
        demo:"https://sithes.neocities.org/TO%20DO/Task",
        github:"https://github.com/SITHESWAR-K/TO-DO-LIST",
        img:todo
    },
    {
        id:10,
        name:"Calculator",
        description:"The project features a clean, responsive layout built with HTML and CSS, prioritizing a straightforward and accessible user experience.",
        tags:["Html","CSS","JS"],
        
        demo:"https://sithes.neocities.org/calculator/MAIN",
        github:"https://github.com/SITHESWAR-K/calculator",
        img:calculator
    },
    
  
] 